export default __webpack_public_path__ + "static/media/icon_bookmark_24_Regular_active.47b870f5.svg";